import { SimNaoEnum } from './SimNaoRadioGroupField'
import { SwitchButtonField, SwitchButtonFieldProps } from './SwitchButtonField'

type SimNaoSwitchButtonFieldProps = Omit<SwitchButtonFieldProps<SimNaoEnum>, 'options'>

export function SimNaoSwitchButtonField(props: SimNaoSwitchButtonFieldProps) {
  return (
    <SwitchButtonField<SimNaoEnum>
      options={[
        { label: 'Sim', value: SimNaoEnum.SIM },
        { label: 'Não', value: SimNaoEnum.NAO },
      ]}
      {...props}
    />
  )
}
